import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons';

const SectionContainer = styled.section`
  padding: 5rem 2rem;
  background: white;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: #2d3748;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  color: #4a5568;
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const TestimonialCard = styled.div`
  background: #f7fafc;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

const QuoteIcon = styled.div`
  color: #4299e1;
  font-size: 1.5rem;
  margin-bottom: 1rem;
`;

const Quote = styled.p`
  color: #2d3748;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const Author = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
`;

const AuthorInfo = styled.div``;

const AuthorName = styled.div`
  color: #2d3748;
  font-weight: bold;
`;

const AuthorTitle = styled.div`
  color: #4a5568;
  font-size: 0.9rem;
`;

const testimonials = [
  {
    quote: "SpinToConnect transformed our virtual conference networking. Attendees loved the interactive and fun approach to making connections.",
    author: "Sarah Johnson",
    title: "Event Director, TechConf",
    avatar: "/images/testimonials/avatar1.jpg"
  },
  {
    quote: "The analytics provided valuable insights into our team building sessions. It's now an essential part of our remote culture.",
    author: "Michael Chen",
    title: "HR Manager, InnovateCorp",
    avatar: "/images/testimonials/avatar2.jpg"
  },
  {
    quote: "Easy to set up and incredibly engaging. Our networking events have seen a 200% increase in participation since implementing SpinToConnect.",
    author: "Emily Rodriguez",
    title: "Community Manager, StartupHub",
    avatar: "/images/testimonials/avatar3.jpg"
  }
];

export const TestimonialsSection: React.FC = () => {
  return (
    <SectionContainer>
      <Content>
        <Header>
          <Title>What Our Clients Say</Title>
          <Subtitle>
            Trusted by leading organizations to create meaningful connections in the virtual space.
          </Subtitle>
        </Header>
        <TestimonialsGrid>
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index}>
              <QuoteIcon>
                <FontAwesomeIcon icon={faQuoteLeft} />
              </QuoteIcon>
              <Quote>{testimonial.quote}</Quote>
              <Author>
                <Avatar 
                  src={testimonial.avatar} 
                  alt={testimonial.author}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = 'https://via.placeholder.com/50';
                  }}
                />
                <AuthorInfo>
                  <AuthorName>{testimonial.author}</AuthorName>
                  <AuthorTitle>{testimonial.title}</AuthorTitle>
                </AuthorInfo>
              </Author>
            </TestimonialCard>
          ))}
        </TestimonialsGrid>
      </Content>
    </SectionContainer>
  );
}; 